import { apiInstance } from "shared/api";
import { ApiActsResponse, PayoutResponse, ReturnPayoutBody } from "./types";

export const getTransactionsForRefund = (): Promise<ApiActsResponse> => {
  return apiInstance
    .get(`/v1/return-transactions`)
    .then((response) => response.data);
};
export const transactionsPayout = (
  id: string,
  body?: ReturnPayoutBody,
): Promise<PayoutResponse> => {
  return apiInstance
    .post(`/v1/return-transactions/${id}/payout`, body)
    .then((response) => response.data);
};
